var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.9811 38.8738L85.8703 41.8826L51.8137 77.3485L32.7046 57.7978L35.5678 54.7629L51.7878 71.3578L82.9811 38.8738Z",
    fill: "#6FCF97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0339 14.9392L20.6913 14.3807C30.9743 5.64427 43.9256 0.863281 57.5 0.863281C88.9321 0.863281 114.413 26.3695 114.413 57.8329C114.413 89.2962 88.9321 114.802 57.5 114.802C26.0678 114.802 0.586914 89.2962 0.586914 57.8329C0.586914 47.7532 3.20856 37.9876 8.20215 29.3466L8.63393 28.5994L12.1914 30.6593L11.7596 31.4065C7.1274 39.4221 4.69669 48.4775 4.69669 57.8329C4.69669 87.0242 28.3376 110.689 57.5 110.689C86.6623 110.689 110.303 87.0242 110.303 57.8329C110.303 28.6415 86.6623 4.97714 57.5 4.97714C44.9021 4.97714 32.8926 9.41035 23.3508 17.5171L22.6933 18.0757L20.0339 14.9392Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.cd528059acb6234241aa0055bb28a5f6.svg";
export { ForwardRef as ReactComponent };